import FormControl from '@mui/material/FormControl';
import InputLabel from "@mui/material/InputLabel/InputLabel";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { SelectChangeEvent } from '@mui/material';
import { useState } from 'react';
import { IAccessControl } from '../../../store/dataSource/types';

export type Props = {
    name: string,
    label: string,
    options: IAccessControl[] | undefined,
    value?: string,  
};

export const PickerAccessControl = ({name, label, options, value}: Props) => {
  const [newValue, setNewValue] = useState('');

  const selectChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    setNewValue(value);
  };

  if (options!==undefined) {
    return (
        <FormControl sx={{ m: 1 }} variant="standard" fullWidth>
        <InputLabel htmlFor={name}>{label}</InputLabel>
        <Select
            id={name}
            value={newValue || value || ''}
            onChange={selectChange}
            sx={{ textAlign: 'left' }}
        >
            {
                options.map((item: IAccessControl, index: number, items: IAccessControl[]) => {
                    return (
                        <MenuItem key={index} value={item.productGroup}>{item.productGroup}</MenuItem>

                    );
                })
            }
        </Select>
        </FormControl>
    );
  } else {
      return(
        <FormControl sx={{ m: 1 }} variant="standard" fullWidth>
            <InputLabel htmlFor={name}>{label}</InputLabel>
            <Select
                id={name}
                value={newValue || value || ''}
                onChange={selectChange}
            >
            </Select>
        </FormControl>
      );
  } 
};

export default PickerAccessControl;